export const PRODUCT_PLACEHOLDER_IMAGE =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120" fill="none">
      <rect width="120" height="120" rx="16" fill="#F8FAFC"/>
      <rect x="18" y="18" width="84" height="84" rx="12" fill="#E2E8F0"/>
      <path d="M38 76l14-16 10 11 20-24 10 29H38z" fill="#CBD5E1"/>
      <circle cx="50" cy="45" r="7" fill="#94A3B8"/>
    </svg>`
  );
